"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiCaretUpGlyph = {
    paths: [
        {
            path: 'M15.7091115,2.20911154 L8.70911154,9.20911154 C8.31858724,9.59963583 7.68542227,9.59963583 7.29489797,9.20911154 L0.294897973,2.20911154 C-0.335066888,1.57914667 0.111099904,0.502004755 1.00200475,0.502004755 L15.0020048,0.502004755 C15.8929096,0.502004755 16.3390764,1.57914667 15.7091115,2.20911154 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Caret Up',
    width: 16,
    height: 10,
    rotate: 180,
};
var muiCaretUp = {
    base: muiCaretUpGlyph,
};
exports.muiCaretUp = muiCaretUp;
//# sourceMappingURL=caretUp.js.map